import React, { useState, useEffect } from "react";
import ReactTable from "../../components/constantComponent/reactTable/ReactTable";
import { Panel, PanelBody } from "./../../components/panel/panel.jsx";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import {
	ApiKey,
	ApiUrl,
	AccessRight,
	WebUrl,
	LanguageKey,
	DEFAULT_PAGE_SIZE,
} from "../../util/Constant";
import { setBusy, setIdle, showMessage } from "../../redux/AppAction";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiEngine from "../../util/ApiEngine";
import moment from "moment";
import { createFormBody } from "../../util/Util.js";

/// <summary>
/// Author : -
/// </summary>
const TodayNewMembers = (props) => {
	const { t } = useTranslation(LanguageKey._PRIMARY);
	let _history = useHistory();

	const _dispatch = useDispatch();
	const [tableData, setTableData] = useState([]);
	const [memberListUrl, setMemberListUrl] = useState(
		`${ApiUrl._API_GET_NEW_MEMBERS_LIST_UNDER_MAIN_ACCOUNT}?`
	);
	const [totalNewRegister, setTotalNewRegister] = useState(0);
	
	let _tableColumns = [
		{
			Header: t("USERNAME"),
			accessor: "username",
			minWidth: 100,
		},
		{
			Header: t("FULLNAME"),
			accessor: "userFullName",
			minWidth: 100,
		},
		{
			Header: t("Upline"),
			accessor: "upline",
			minWidth: 100,
		},
		{
			Header: t("EMAIL"),
			accessor: "email",
			minWidth: 100,
		},
		{
			Header: t("PHONE"),
			accessor: "phoneNumber",
			minWidth: 100,
		},
		{
			Header: t("CREATED_TIME"),
			accessor: "createdTime",
			minWidth: 100,
			Cell: ({ row }) => {
				return (
					<div>
						{moment(row.original.createdTime)
							.add(8, "hours")
							.format("YYYY-MM-DD HH:mm:ss")}
					</div>
				);
			},
		},
		{
			Header: t("DEPOSITED"),
			accessor: "deposited",
			minWidth: 100,
			Cell: ({ row }) => {
				return <div>{row.original.deposited ? t("YES") : t("NO")}</div>;
			},
		},
	];

	useEffect(() => {
		// getNewMemberList();
		newMemberRegister();
	}, []);

	useEffect(() => {
		const markAsRead = async () => {
			if (tableData?.totalCount > 0 && totalNewRegister > 0) {
				await updateNewMemberIsRead(tableData?.data);
			}
		};
		markAsRead();

	}, [tableData]);

	const newMemberRegister = async ()=>{
		await fetch(ApiUrl._API_GET_NEW_MEMBER_REGISTER_COUNT, {
			method: ApiKey._API_GET,
			headers: {
				"Content-Type": ApiKey._API_FORM_URLENCODED,
				"X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
			},
		})
			.then((response) => response.json())
			.then((responseJson) => {
				if (responseJson[ApiKey._API_SUCCESS_KEY]) {
					setTotalNewRegister(responseJson[ApiKey._API_DATA_KEY]);
				}
			});
	}
	const updateAllNewMemberIsRead = async () => {

		_dispatch(setBusy());
		fetch(ApiUrl._API_UPDATE_ALL_NEW_MEMBER_NOTIFY, {
			method: ApiKey._API_POST,
			headers: {
				"Content-Type": ApiKey._API_FORM_URLENCODED,
				"X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
			},
		})
		.then((response) => response.json())
		.then((responseJson) => {
	
			_dispatch(
				showMessage(
					responseJson[ApiKey._API_SUCCESS_KEY], t("SUCCESS")
				)
			);

			newMemberRegister();

			_dispatch(setIdle());


		});
		
	};
	const updateNewMemberIsRead = async (list) => {
		_dispatch(setBusy());

		const promises = list.map((option) => {
			let params = {};

			params = {
				username: option.username,
				
			};

			let formBody = createFormBody(params);
			return fetch(ApiUrl._API_UPDATE_NEW_MEMBER_NOTIFY, {
				method: ApiKey._API_POST,
				headers: {
					"Content-Type": ApiKey._API_FORM_URLENCODED,
					"X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
				},
				body: formBody,
			})
				.then((response) => response.json())
				.then((responseJson) => {


				});
			
		})

		await Promise.all(promises);
		_dispatch(setIdle());

		newMemberRegister();


		
	};

	const getNewMemberList = async () => {

		let apiUrl = ApiUrl._API_GET_NEW_MEMBERS_LIST_UNDER_MAIN_ACCOUNT;
		var responseJson = await ApiEngine.get(apiUrl);
		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			let data = responseJson[ApiKey._API_DATA_KEY];
			setTableData(data);
		}
	};

	return (
		<div>
			<h1 className="page-header">
				{t("NEW_MEMBERS_7_DAYS")}
				<button type="button" 
					className="btn btn-primary" 
					style={{float: "right"}} 
					onClick={updateAllNewMemberIsRead}
					disabled={totalNewRegister > 0 ? false : true}
				>
					Marks All As Read
				</button>
			</h1>
			<Panel>
				<div className="row">
					<div className="col-lg-12">
						<PanelBody>
							<ReactTable 
								fetchUrl={memberListUrl}
								// data={tableData} 
								fetchedData={(data) => setTableData(data)}
								columns={_tableColumns} 
								// filterable 
							/>
						</PanelBody>
					</div>
				</div>
			</Panel>
		</div>
	);
};

export default TodayNewMembers;
